var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "sidebar-lottery" }, [
    _c(
      "button",
      {
        staticClass: "sidebar-lottery-info",
        attrs: {
          type: "button",
          "aria-label": _vm.$t("couponLottery.rules_btn"),
        },
        on: {
          click: function ($event) {
            return _vm.$emit("open-rules")
          },
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    ),
    _c("p", { staticClass: "sidebar-lottery-eyebrow" }, [
      _vm._v("★ " + _vm._s(_vm.$t("couponLottery.daily_draw_title")) + " ★"),
    ]),
    _c("div", { staticClass: "sidebar-lottery-title" }, [
      _c("strong", [_vm._v(_vm._s(_vm.$t("coupon.activity_button_text")))]),
    ]),
    _c("p", { staticClass: "sidebar-lottery-range" }, [
      _vm._v("10% "),
      _c("span", [_vm._v("~")]),
      _vm._v(" 30% " + _vm._s(_vm.$t("coupon.discount_label"))),
    ]),
    _c(
      "div",
      {
        staticClass: "sidebar-lottery-stage",
        attrs: { "aria-hidden": "true" },
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "sidebar-coupon-ticket" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("coupon.discount_label")))]),
          _vm._m(1),
        ]),
      ]
    ),
    _c("div", { staticClass: "sidebar-lottery-divider" }),
    _c(
      "button",
      {
        staticClass: "sidebar-activity bg_color",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("open-lottery")
          },
        },
      },
      [_c("span", [_vm._v("立即抽獎")])]
    ),
    _c("p", { staticClass: "sidebar-lottery-status" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(
            _vm.$t("couponLottery.unlocked_extra", { amount: _vm.lotteryCount })
          ) +
          "\n\t"
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sidebar-coupon-options" }, [
      _c("span", [_vm._v("10%")]),
      _c("span", [_vm._v("20%")]),
      _c("span", [_vm._v("30%")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sidebar-coupon-value" }, [
      _c("small", [_vm._v("最高")]),
      _c("strong", [_vm._v("30%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }